import type React from 'react';
import { useMemo } from 'react';
import { DeploymentSelector } from '../../../components/message-composer/chat-context/selectors';
import { useCustomerOptions } from '../../../hooks/portal/useCustomerOptions';
import type { ControlComponentProps } from './types';

const CUSTOMER_NOUN = { singular: 'customer', plural: 'customers' } as const;

/**
 * The cascade's first step, above the deployment it narrows.
 *
 * Ignores the `options` the filter bar resolved for it: customer names live only in
 * customer-portal-api, so the backend answers this dimension with an empty list.
 */
export const CustomerControl: React.FC<ControlComponentProps> = ({
  control,
  templateProducts,
  value,
  onChange,
  disabled,
}) => {
  const { items, totalCount, status, isPortalSource } = useCustomerOptions(templateProducts);

  const multiple = control.multiple ?? false;
  const selectedItems = useMemo(() => value.map((id) => ({ id, label: id })), [value]);

  return (
    <DeploymentSelector
      items={isPortalSource ? items : []}
      selectedItems={selectedItems}
      onSelectionChange={(picked) => onChange(picked.map((item) => item.id))}
      multiple={multiple}
      status={status}
      disabled={disabled || !isPortalSource}
      noun={CUSTOMER_NOUN}
      variant="field"
      fieldLabel={control.label}
      compact
      menuOpenBelow
      searchPlaceholder={`Search ${control.label.toLowerCase()}...`}
      totalCount={totalCount}
    />
  );
};
